import React, { Fragment, useEffect } from "react";
import "./App.css";
import Routers from "./Routes";
import AnimationThemeProvider from "./_helper/AnimationTheme/AnimationThemeProvider";
import CustomizerProvider from "./_helper/customizer/CustomizerProvider";
import { LoadingProvider } from "./_helper/loading/LoadingContext";
import { addEvent, clearItem, LOG_OUT, removeEvent, Storage } from "./Constant/common";

function App() {
  useEffect(() => {
    const handleLogout = (event) => {
      if (event.key === LOG_OUT) {
        clearItem();
        window.location.href = "/login";
      }
    };
    addEvent(Storage, handleLogout);
    return () => {
      removeEvent(Storage, handleLogout);
    };
  }, []);
  return (
    <Fragment>
      <CustomizerProvider>
        <AnimationThemeProvider>
          <LoadingProvider>
            <Routers />
          </LoadingProvider>
        </AnimationThemeProvider>
      </CustomizerProvider>
    </Fragment>
  );
}
export default App;
